import React, { useEffect, useState, useRef } from "react";
import Layout from "../components/Layout";
import { api } from "../api";

function SubirReciboModal({ empleados, onClose, onSuccess }) {
  const [empleadoId, setEmpleadoId]  = useState("");
const [concepto, setConcepto] = useState("");
const [quincena, setQuincena] = useState("1ra quincena");
const [mes, setMes] = useState("Enero");
const [anio, setAnio] = useState(new Date().getFullYear().toString());
  const [file, setFile]              = useState(null);
  const [error, setError]            = useState("");
  const [loading, setLoading]        = useState(false);
  const fileRef = useRef();

  async function handleSubmit(e) {
    e.preventDefault();
    if (!file) return setError("Seleccioná un archivo PDF");
    setError(""); setLoading(true);
    try {
      const fd = new FormData();
      fd.append("pdf", file);
      fd.append("empleado_id", empleadoId);
      fd.append("concepto", concepto);
      fd.append("periodo", `${quincena} ${mes} ${anio}`);
      await api.subirRecibo(fd);
      onSuccess();
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:20 }}>
      <div className="card" style={{ maxWidth:480,width:"100%" }}>
        <h3 style={{ color:"var(--navy)",marginBottom:20 }}>Subir recibo</h3>
        <form onSubmit={handleSubmit} style={{ display:"flex",flexDirection:"column",gap:16 }}>
          <div className="input-group">
            <label>Empleado</label>
            <select value={empleadoId} onChange={e=>setEmpleadoId(e.target.value)} required>
              <option value="">Seleccioná un empleado…</option>
              {empleados.map(e => (
                <option key={e.id} value={e.id}>{e.apellido}, {e.nombre} — DNI {e.dni}</option>
              ))}
            </select>
          </div>
<div className="input-group">
            <label>Concepto</label>
            <select value={concepto} onChange={e=>setConcepto(e.target.value)} required>
              <option value="">Seleccioná un concepto…</option>
              <option value="Sueldo">Sueldo</option>
              <option value="Aguinaldo">Aguinaldo</option>
              <option value="Liquidacion Final">Liquidacion Final</option>
            </select>
          </div>
          <div className="input-group">
            <label>Período</label>
            <div style={{ display:"flex", gap:8 }}>
              <select value={quincena} onChange={e=>setQuincena(e.target.value)}>
                <option value="1ra quincena">1ra quincena</option>
                <option value="2da quincena">2da quincena</option>
                <option value="Mensual">Mensual</option>
              </select>
              <select value={mes} onChange={e=>setMes(e.target.value)}>
                {["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"].map(m => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
              <select value={anio} onChange={e=>setAnio(e.target.value)}>
                {Array.from({length: 74}, (_,i) => 2026+i).map(a => (
                  <option key={a} value={a}>{a}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="input-group">
            <label>Archivo PDF</label>
            <input type="file" accept="application/pdf" ref={fileRef}
              onChange={e=>setFile(e.target.files[0])} required />
          </div>
          {error && <div className="alert alert-error">{error}</div>}
          <div style={{ display:"flex",gap:10 }}>
            <button type="button" className="btn btn-full" onClick={onClose} disabled={loading}>Cancelar</button>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? "Subiendo…" : "Subir recibo"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function RecibosAdmin() {
  const [recibos, setRecibos]       = useState([]);
  const [empleados, setEmpleados]   = useState([]);
  const [loading, setLoading]       = useState(true);
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroPeriodo, setFiltroPeriodo] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [modalSubir, setModalSubir] = useState(false);
  const [error, setError]           = useState("");
  const [success, setSuccess]       = useState("");
  const [procesando, setProcesando] = useState(null);

  async function cargar() {
    setLoading(true);
    try {
      const [r, e] = await Promise.all([
        api.getRecibos({ estado: filtroEstado, periodo: filtroPeriodo }),
        api.getEmpleados(),
      ]);
      setRecibos(r); setEmpleados(e);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { cargar(); }, [filtroEstado, filtroPeriodo]);

  async function publicar(id) {
    setProcesando(id);
    try {
      await api.publicarRecibo(id);
      setSuccess("Recibo publicado. Se envió notificación al empleado.");
      await cargar();
    } catch (e) { setError(e.message); }
    finally { setProcesando(null); }
  }

  async function eliminar(id) {
    if (!window.confirm("¿Eliminar este recibo? No se puede deshacer.")) return;
    setProcesando(id);
    try {
      await api.eliminarRecibo(id);
      await cargar();
    } catch (e) { setError(e.message); }
    finally { setProcesando(null); }
  }

const recibiosFiltrados = busqueda
    ? recibos.filter(r => {
        const q = busqueda.toLowerCase();
        return `${r.nombre} ${r.apellido} ${r.dni}`.toLowerCase().includes(q);
      })
    : recibos;
  const periodos = [...new Set(recibiosFiltrados.map(r => r.periodo))].sort().reverse();

  return (
    <Layout>
      {modalSubir && (
        <SubirReciboModal
          empleados={empleados}
          onClose={() => setModalSubir(false)}
          onSuccess={() => { setModalSubir(false); setSuccess("Recibo subido. Podés publicarlo cuando quieras."); cargar(); }}
        />
      )}

      <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:24,flexWrap:"wrap",gap:12 }}>
        <div>
          <h1 style={{ fontSize:24,fontWeight:700,color:"var(--navy)" }}>Recibos</h1>
          <p style={{ color:"var(--gray)",marginTop:4 }}>{recibos.length} recibos</p>
        </div>
        <div style={{ display:"flex",gap:10 }}>
<button className="btn" onClick={async () => {
  const token = localStorage.getItem("token");
  const res = await fetch("/api/admin/recibos/export", { headers: { Authorization: `Bearer ${token}` } });
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `recibos-${new Date().toISOString().slice(0,10)}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}}>Exportar Excel</button>          <button className="btn btn-primary" onClick={() => setModalSubir(true)}>+ Subir recibo</button>
        </div>
      </div>

      {error && <div className="alert alert-error" style={{ marginBottom:16 }}>{error}</div>}
      {success && <div className="alert alert-success" style={{ marginBottom:16 }}>{success}</div>}

      <div style={{ display:"flex",gap:12,marginBottom:20,flexWrap:"wrap",alignItems:"center" }}>
        <select className="input-group input"
          style={{ padding:"8px 12px",border:"1.5px solid var(--border)",borderRadius:"var(--radius)",fontFamily:"inherit",fontSize:14 }}
          value={filtroEstado} onChange={e=>setFiltroEstado(e.target.value)}>
          <option value="">Todos los estados</option>
          <option value="pendiente">Pendiente</option>
          <option value="firmado">Firmado</option>
        </select>
        <select
          style={{ padding:"8px 12px",border:"1.5px solid var(--border)",borderRadius:"var(--radius)",fontFamily:"inherit",fontSize:14 }}
          value={filtroPeriodo} onChange={e=>setFiltroPeriodo(e.target.value)}>
          <option value="">Todos los períodos</option>
          {periodos.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        <input
          type="search"
          placeholder="Buscar por nombre o DNI…"
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          style={{ padding:"8px 12px", border:"1.5px solid var(--border)", borderRadius:"var(--radius)", fontFamily:"inherit", fontSize:14, minWidth:220 }}
        />
      </div>

      {loading ? (
        <div style={{ padding:60,textAlign:"center" }}><div className="spinner" /></div>
      ) : recibiosFiltrados.length === 0 ? (
        <div className="card" style={{ textAlign:"center",padding:48,color:"var(--gray)" }}>
          No hay recibos con estos filtros.
        </div>
      ) : (
        <div className="card" style={{ padding:0,overflow:"hidden" }}>
          <table>
            <thead>
              <tr>
                <th>Empleado</th>
                <th>Concepto</th>
                <th>Período</th>
                <th>Estado</th>
                <th>Firmado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {recibos.map(r => (
                <tr key={r.id}>
                  <td>
                    <div style={{ fontWeight:500 }}>{r.apellido}, {r.nombre}</div>
                    <div style={{ fontSize:12,color:"var(--gray)" }}>DNI {r.dni}</div>
                  </td>
                  <td>{r.concepto}</td>
                  <td>{r.periodo}</td>
                  <td>
                    <span className={`badge badge-${r.publicado_at ? r.estado : "borrador"}`}>
                      {!r.publicado_at ? "Borrador" : r.estado === "pendiente" ? "Pendiente" : "Firmado"}
                    </span>
                  </td>
                  <td style={{ fontSize:13,color:"var(--gray)" }}>
                    {r.firmado_at ? (
                      <div>
                        <div>{new Date(r.firmado_at).toLocaleString("es-AR")}</div>
                        <div style={{ fontSize:11,marginTop:2 }}>{r.firma_ip}</div>
                      </div>
                    ) : "—"}
                  </td>
                  <td>
                    <div style={{ display:"flex",gap:8 }}>
                      <button className="btn btn-sm" onClick={() => {
  const token = localStorage.getItem("token");
  fetch(`/api/recibos/${r.id}/pdf`, { headers: { Authorization: `Bearer ${token}` } })
    .then(res => res.blob())
    .then(blob => { const url = URL.createObjectURL(blob); window.open(url); });
}}>PDF</button>
                      {!r.publicado_at && (
                        <button className="btn btn-primary btn-sm"
                          disabled={procesando === r.id}
                          onClick={() => publicar(r.id)}>
                          {procesando === r.id ? "…" : "Publicar"}
                        </button>
                      )}
                      {r.estado !== "firmado" && (
                        <button className="btn btn-danger btn-sm"
                          disabled={procesando === r.id}
                          onClick={() => eliminar(r.id)}>
                          Eliminar
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
